import React from 'react';

import './skeleton.scss';

const Skeleton = (props) => {
    return <span className='skeleton' style={props}></span>;
};

export default Skeleton;
